__turbopack_context__.v({
  "fluid": "Container-module-scss-module__6AEC1q__fluid",
  "lg": "Container-module-scss-module__6AEC1q__lg",
  "md": "Container-module-scss-module__6AEC1q__md",
  "root": "Container-module-scss-module__6AEC1q__root",
  "sm": "Container-module-scss-module__6AEC1q__sm",
  "xl": "Container-module-scss-module__6AEC1q__xl",
  "xs": "Container-module-scss-module__6AEC1q__xs",
});
